import styled from 'styled-components';

import { fontFamilyPrimary, colorGray } from 'styles/variables';

export const Wrapper = styled.label`
  color: ${colorGray};
  font-family: ${fontFamilyPrimary};
  font-size: 10px;
  line-height: 12px;
  position: absolute;
  z-index: 1;
  background-color: #fff;
  padding: 2px;
  border-radius: 4px;
  left: 16px;
  top: -7px;
`;

export default Wrapper;
